import {Fuego} from "@nandorojo/swr-firestore";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import "firebase/firestore";
import "firebase/functions";
import "firebase/performance";
import "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID,
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const fuego = new Fuego(firebaseConfig);

export const auth = firebase.auth();

export const storage = firebase.storage();

export const functions = firebase.functions();

export const db = firebase.firestore();

export const {analytics, performance} = firebase;

export const {arrayRemove, arrayUnion} = firebase.firestore.FieldValue;

export const timestamp = firebase.firestore.FieldValue.serverTimestamp();

export default firebase;
